import { decode } from "./decode.js";
const decodeHookResult = (codec, hookResult) => {
  const data = [];
  const errors = [];
  for (const dataElement of hookResult.data) {
    const { value, error } = decode(codec, dataElement);
    if (error) {
      errors.push(error);
    } else {
      data.push(value);
    }
  }
  return {
    data,
    errors: [...errors, ...hookResult.errors]
  };
};
export {
  decodeHookResult
};
//# sourceMappingURL=decodeHookResult.js.map
